<mat-card class="mat-elevation-z4">
  <mat-card-header>
    <img
      src="{{ profileURL$ | async }}"
      mat-card-avatar
      ngClass.xs="avatar-xs"
      class="card-image"
    />
    <mat-card-title>{{ result.service.title }}</mat-card-title>
    <mat-card-subtitle>{{ type }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-chip-list class="tag-list">
      <mat-chip
        selected
        color="accent"
        *ngFor="let tag of result.service.tags"
        >{{ tag }}</mat-chip
      >
      <mat-chip
        selected
        color="primary"
        *ngFor="let location of result.service.locations"
        >{{ location }}</mat-chip
      >
    </mat-chip-list>
    <p class="padded-top">{{ result.service.description }}</p></mat-card-content
  >
  <mat-card-actions
    *ngIf="
      (identity.userLoggedIn$ | async) &&
      (identity.userProfileComplete$ | async)
    "
  >
    <button
      *ngIf="(contact$ | async) !== (false || null || undefined) as contact"
      fxFlex="100"
      fxFlex.gt-xs="20"
      mat-raised-button
      color="primary"
      routerLink="/my-contacts/{{ (contact$ | async)?.serviceKey }}/{{
        (contact$ | async)?.clientUserKey
      }}"
    >
      View Conversation
    </button>
    <button
      fxFlex="100"
      fxFlex.gt-xs="20"
      *ngIf="(contact$ | async) === (false || null || undefined)"
      mat-raised-button
      color="primary"
      (click)="openContactDialog()"
    >
      Contact
    </button>
    <button
      fxFlex="100"
      fxFlex.gt-xs="20"
      mat-raised-button
      color="primary"
      (click)="openShareOptionsPanel()"
    >
      Share
    </button>
  </mat-card-actions>
</mat-card>
